module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_j_normal.2a59513d.png";